import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CheckoutRoutes } from '@checkout/util-models';
import { BasketFacade } from '@domgen/dgx-fe-basket';
import { CmsContainer, CmsPage } from '@domgen/dgx-fe-cms';
import { PaymentType } from '@domgen/dgx-fe-common';
import { Observable, combineLatest } from 'rxjs';

export interface ViewModel {
  cmsData: CmsPage;
}

@Injectable()
export class PaymentMethodComponentService {
  readonly vm$: Observable<ViewModel> = combineLatest({
    cmsData: this.cmsContainer.content$,
  });

  constructor(
    private readonly basketFacade: BasketFacade,
    private readonly cmsContainer: CmsContainer<CmsPage>,
    private readonly router: Router
  ) {}

  onFormSubmit(paymentType: PaymentType): void {
    this.basketFacade.selectPaymentType(paymentType);

    paymentType === PaymentType.Card
      ? this.router.navigateByUrl(CheckoutRoutes.Card)
      : this.router.navigateByUrl(CheckoutRoutes.DirectDebit);
  }
}
